<template>
<v-app id="inspire">
    <v-navigation-drawer
        v-model="drawer"
        disable-resize-watcher
        app
        temporary
        style="width: 450px"
    >
       <m-main-navigation
            v-model="drawer"
            v-on:sign-in-as="onClickFooter" />
    </v-navigation-drawer>

    <v-app-bar app
        :color="color"
        dark
        dense
    >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title>
            <slot name="title">
                {{current_title}}
            </slot>
        </v-toolbar-title>
        <v-spacer/>

        <v-icon
            v-on:click="onClickHelp"
            style="margin-right: 5px"
            v-if="help_url != null"
        >
            mdi-help-box-multiple-outline
        </v-icon>

        <v-icon
            v-on:click="toggleMute"
            style="margin-right: 5px"
        >
            {{muted ? 'mdi-volume-off' : 'mdi-volume-high'}}
        </v-icon>

        <v-icon
            v-on:click="onClickHome"
        >
            mdi-home
        </v-icon>

    </v-app-bar>

    <v-main class="main">
        <slot></slot>
    </v-main>


    <m-internal-error-dialog
        ref="internal_error_dialog"
    />

    <m-server-unavailable-dialog
        ref="server_unavailable_dialog"
    />

    <m-globals/>

    <m-dialog-sign-in-as
        :after_route="sign_in_as_route"
        ref="dialog-sign-in-as"
    />

    <v-footer
        dark padless
        app
        v-if="$rc.isSignedIn() && ($rc.$state.showSignedInAsFooter() || is_any_archived)"
        :style="{
            backgroundColor: footer_background_color, 
            color: footer_text_color 
        }"
        >
        <div
            style="text-align: center; width: 100%; font-size: 12px; padding-top: 3px; padding-bottom: 3px; position: relative; cursor: pointer"
                        v-on:click="onClickFooter"

        >
            <span
                v-if="$rc.$state.showSignedInAsFooter()"
            >
                {{ $rc.$state.signedInFooterText() }}
            </span>

            <span v-if="$rc.$state.showSignedInAsFooter() && is_any_archived" :style="{ margin: '0 5px' }">|</span>

            <span
                v-if="is_any_archived"
                style="font-weight: bold;"
            >
                {{ archived_status_message }}
            </span>
        </div>

        <div
            style="position: absolute; top: 0; bottom: 0; right: 7px; display: flex; align-items: center;"
            v-if="$rc.$state.showSignedInAsFooter()"
        >
            <v-icon
                size="15"
                v-on:click.stop="hideSignInAsFooter()" style="cursor: pointer;"
            >
                mdi-close
            </v-icon>
        </div>
    </v-footer>
    </v-app>
</template>

<script>
const _ = require('lodash');
export default {
    props: { 
        title: {
            type: String, Array,
            default: 'Set my \'title\' property!'
        },
        color: {
            type: String,
            default: 'primary'
        },
        title_jump_to_organization_id: {
            type: String,
            default: function() { return null; },
        },
        help_url: {
            type: String,
            default: function() { return null; },
        },
        sign_in_as_route: {
            type: Object,
            default: function() { return null; },
        }
    },

    data() { 
        return {
            drawer: false,
            muted: false,
            current_title_source: null,
            current_title: null,
        }
    },

    computed: { 
        is_any_archived() {
          return this.$rc.$state.isAccountArchived() || this.$rc.$state.isOrganizationArchived();
        },
        archived_status_message() {
          const account_archived = this.$rc.$state.isAccountArchived();
          const org_archived = this.$rc.$state.isOrganizationArchived();
          if (account_archived && org_archived) {
            return "ARCHIVED ACCOUNT & ORGANIZATION | STAFF ACCESS ONLY";
          } else if (account_archived) {
            return "ARCHIVED ACCOUNT | STAFF ACCESS ONLY";
          } else if (org_archived) {
            return "ARCHIVED ORGANIZATION | STAFF ACCESS ONLY";
          }
          return "";
        },
        footer_background_color() {
          if (this.is_any_archived) {
            return '#ffdcdc'; 
          }
          return undefined; // Let Vuetify's `dark` prop and theme handle normal background
        },
        footer_text_color() {
          if (this.is_any_archived) {
            return '#000000'; 
          }
          return undefined; // Let Vuetify's `dark` prop and theme handle normal text color
        }
    },

    created () { 
        this.$event_bus.$off('backstop-error-handler');
        this.$event_bus.$on('backstop-error-handler', this.onUnhandledAPIError);

        this.$event_bus.$off('router-push');
        this.$event_bus.$on('router-push', this.onRouterPush);

        this.$event_bus.$on('employee-notification', this.onEmployeeNotification);
    },

    beforeDestroy () { 
        this.$event_bus.$off('backstop-error-handler',this.onUnhandledAPIError);
        this.$event_bus.$off('router-push',this.onRouterPush);
        this.$event_bus.$off('employee-notification',this.onEmployeeNotification);
    },

    mounted () { 
        this.muted = this.$rc.$state.muted;
        this.updateTitle();

        let snackbar_params = this.$rc.clear_next_page_snackbar();

        if ( snackbar_params != null )
        {
            setTimeout(() => {
                this.$rc.snackbar(snackbar_params.text, snackbar_params.timeout);
            }, 150);
        }

        if ( this.$rc.isSignedIn() && this.$rc.isAuthActorProhibitedFromUsingFrontEnd() )
        {
            this.$rc.signOut();

            this.$router.push({
                'name': 'sign-in',
            }).catch(e=>{}); // swallow any exception
        }

        if ( this.$rc.$state.isAuthActorSystemAdmin() )
        {
            document.title = this.$rc.$state.getOrganizationLabel();
        }
    },

    methods: { 
        toggleMute() {
            if ( !this.$rc.$state.hasAlertSound() )
            {
                alert("You can not unmute because you have not selected an alert sound.\n\nTo Select an alert sound, go to your account settings and choose one on the 'Sounds and Notifications' tab.");
                return;
            }

            this.muted = !this.muted;
            this.$rc.$state.setMuted(this.muted);
        },

        onClickHome() {
            this.closeDrawer();
            this.quietPush('home');
        },

        drawerGoPickups()
        {
            this.closeDrawer();

            this.$router.push({
                'name': 'search-pickups',
                'params' : {
                    'organization_id' : this.$rc.$state.organization_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        closeDrawer()
        {
            this.drawer = false;
        },
        quietPush(name)
        {
            this.$router.push({
                'name': name,
                'params' : {
                    'employee_id' : this.$rc.$state.employee_id,
                    'organization_id' : this.$rc.$state.organization_id,
                }
            });
        },

        onUnhandledAPIError(response)
        {
            if ( response === null || response.http_status_code == null )
            {
                this.$refs['internal_error_dialog'].showDialog(response);
                return;
            }

            if ( response.http_status_code === 503 || response.http_status_code === 408 )
            {
                this.$refs['server_unavailable_dialog'].showDialog(response);
                return;
            }

            this.$refs['internal_error_dialog'].showDialog(response);
        },

        onRouterPush(route)
        {
            this.$router.push(route).catch(e=>{}); // swallow any exception
        },

        onEmployeeNotification(notification)
        {
            this.$rc.snackbar(notification.text,3000);
        },

        hideSignInAsFooter()
        {
            this.$rc.$state.hideSignInAsFooter();
            this.$forceUpdate();
        },

        onClickFooter()
        {
            this.$refs['dialog-sign-in-as'].showDialog();
        },

        updateTitle()
        {
            let normalized = [];

            if ( this.title != null )
            {
                normalized = Array.isArray(this.title) ? this.title : [this.title];
            }

            if ( _.isEqual(this.current_title_source, normalized) )
                return; // no change required...

            this.current_title_source = _.cloneDeep(normalized);

            let first_title_without_variables = null;


            if ( normalized.length > 0 && !this.$rc.hasPersonalizeVariables(normalized[0]) )
            {
                this.current_title = normalized[0];
                return;
            }

            for ( let i = 0; i < normalized.length; i++ )
            {
                if( !this.$rc.hasPersonalizeVariables(normalized[i]) && first_title_without_variables == null )
                {
                    first_title_without_variables = normalized[i];
                }
            }

            this.current_title = null;

            if ( first_title_without_variables != null )
            {
                this.current_title = first_title_without_variables;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/organization/personalize',

                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'employee_id': this.$route.params.employee_id,
                        'patterns': normalized,
                    },

                'on_success': (data) => {
                        if ( data.result != null )
                            this.current_title = data.result;
                    },

                'on_error': () => {},
            });
        },

        onClickHelp()
        {
            window.open(this.help_url, '_blank');
        },

        onClickMenuItem(item)
        {
            if ( item.page != null )
            {
                this.closeDrawer();
                this.quietPush(item.page);
                return;
            }

            item.on_click();
        },
    },

    watch: {
        title(newValue, oldValue) {
            this.updateTitle();
        }
    },
}
</script>

<style scoped>
.main
{
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 10px;
}
</style>